/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsBlog_custom = {
  init: function($section){

    // Add settings from schema to current object
    window.PXUTheme.jsBlog_custom = $.extend(this, window.PXUTheme.getSectionData($section));

      $('.blog_filter').on('change', function() {
        window.PXUTheme.jsBlog_custom.blogFilter($(this));
      });

  },
  blogFilter: function(el) {
    let url = el.val();
    window.location = url;
  },
  unload: function($section) {
    $('.blog_filter').off();
  }
}

/******/ })()
;